import { MahnwesenView } from "../payment-reminder.types";

const MAHNWESEN_VIEWS: MahnwesenView[] = [
	"due",
	"collection",
	"paused",
	"history",
];

export const MAHNWESEN_HISTORY_PATH = "/debitoren/mahnwesen?view=history";

export const parseMahnwesenView = (value: string | null): MahnwesenView =>
	MAHNWESEN_VIEWS.find((view) => view === value) ?? "due";
